import { Star } from "lucide-react";

export default function ReviewerBadge() {
  return (
    <div 
      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-amber-50 to-yellow-50 
                 border border-amber-200 rounded-full text-xs font-semibold text-amber-700
                 shadow-sm animate-fadeIn"
      data-testid="reviewer-badge"
    >
      <Star size={12} className="fill-amber-400 text-amber-400" />
      <span>Reviewer Access Enabled</span>
    </div>
  );
}
